module.exports = __webpack_public_path__ + "static/media/Upload.d1f0fd09.svg";